import React, { useState } from "react";
import { Table } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Collapse, Badge } from "antd";
const { Panel } = Collapse;
import {
  imagesend,
  pdficon,
  pdficon3,
  plusicon,
  refreshicon,
  pdficon5,
} from "../imagepath";

import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { generateCsv, handleShowJson } from "../../utils/constant/constant";
import { toast } from "react-toastify";
import { getOrgSettings } from "../../connections/getOrgSettings";
import { deleteOrgSettings } from "../../connections/deleteOrgSettings";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import { Dropdown, Menu } from "antd";
import { getOrgFeature } from "../../connections/getOrgFeature";
import { putEnableDisableFeature } from "../../connections/putEnableDisableFeature";
import { putOrgFeature } from "../../connections/putOrgFeature";

const OrgFeature = () => {
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const {
    user: { user },
  } = useSelector((store) => store);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [enable, setEnable] = useState(false);
  const {
    data: OrgListData,
    isLoading: OrgListLoader,
    refetch: OrgListRefetch,
  } = useQuery({
    queryKey: ["getOrgFeature", page, pageSize],
    queryFn: () => getOrgFeature(user?.token, null, page, pageSize),
    enabled: !!user?.token,
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });

  const columns = [
    {
      title: "Key",
      dataIndex: "key",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Is Active",
      dataIndex: "active",
      render: (_, record) => (
        <div className="status-toggle d-flex justify-content-between align-items-center">
          <input
            disabled={enable}
            type="checkbox"
            id={`status_${record?.id}`} // Dynamic ID based on record ID
            className="check"
            checked={record?.active} // Controlled by state
            onChange={async (e) => {
              const newValue = e.target.checked;
              const payload = {
                feature: {
                  active: newValue,
                },
              };
              try {
                setEnable(true);
                const data = await putOrgFeature(
                  user?.token,
                  payload,
                  record?.id,
                ); // Call API with the correct ID
                if (data) {
                  OrgListRefetch();
                  setEnable(false);
                }
              } catch (error) {
                setEnable(false);
                toast.error("Failed to update status"); // Handle failure gracefully
              }
            }}
          />
          <label
            htmlFor={`status_${record?.id}`}
            className="checktoggle"
            style={{
              backgroundColor: record?.active ? "green" : "red",
              color: "white !important",
            }}
          >
            Checkbox
          </label>
        </div>
      ),
    },
    // {
    //   title: "Is Enabled",
    //   dataIndex: "enabled",
    //   render: (text) => (
    //     <span
    //       className={
    //         text ? "custom-badge status-green" : "custom-badge status-pink"
    //       }
    //     >
    //       {" "}
    //       {text ? "True" : "False"}
    //     </span>
    //   ),
    // },
    {
      title: "",
      dataIndex: "actions",
      render: (_, record) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() =>
            navigate("/admin/update_organization_feature", { state: record })
          }
        >
          <i className="far fa-edit me-1" /> Edit
        </button>
      ),
    },
    // {
    //   title: "",
    //   dataIndex: "FIELD8",
    //   render: (_, record) => (
    //     <Dropdown
    //       overlay={
    //         <Menu>
    //           <Menu.Item
    //             key="edit"
    //             onClick={() =>
    //               navigate("/admin/update_organization_feature", {
    //                 state: record,
    //               })
    //             }
    //           >
    //             <i className="far fa-edit me-2" /> Edit
    //           </Menu.Item>
    //           {record?.enabled ? (
    //             <Menu.Item
    //               className="dropdown-item"
    //               to="#"
    //               data-bs-toggle="modal"
    //               data-bs-target="#delete_patient"
    //               key="delete"
    //               onClick={() => {
    //                 setDeleteId(record?.id);
    //                 setEnable("disable");
    //               }}
    //             >
    //               <i className="fa-solid fa-toggle-off"></i> {"Disable feature"}
    //             </Menu.Item>
    //           ) : (
    //             <Menu.Item
    //               className="dropdown-item"
    //               to="#"
    //               data-bs-toggle="modal"
    //               data-bs-target="#delete_patient"
    //               key="delete"
    //               onClick={() => {
    //                 setDeleteId(record?.id);
    //                 setEnable("enabled");
    //               }}
    //             >
    //               <i className="fa-solid fa-toggle-on"></i> {"Enabled feature"}
    //             </Menu.Item>
    //           )}
    //         </Menu>
    //       }
    //       trigger={["click"]}
    //       placement="bottomRight"
    //     >
    //       <Link
    //         to="#"
    //         style={{ marginRight: 5 }}
    //         className="action-icon"
    //         // data-bs-toggle="dropdown"
    //         // aria-expanded="false"
    //       >
    //         <i className="fas fa-ellipsis-v" />
    //       </Link>
    //     </Dropdown>
    //   ),
    // },
  ];
  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
    // refetchSuppliersList();
  };
  const handleEnableDisableFeature = async (e) => {
    e.preventDefault();
    const active = enable === "enabled" ? true : false;
    try {
      const data = await putEnableDisableFeature(user?.token, active, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success(`Organization feature ${enable} successfully`);
        if (enable === "enabled") {
          setEnable("disabled");
        } else {
          setEnable("enabled");
        }
        setDeleteId("");
        OrgListRefetch();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const downloadPdf = (patients) => {
    // Return if no data
    if (!patients || patients.length === 0) return;

    // Initialize PDF document
    const doc = new jsPDF({
      unit: "mm",
      format: "a4",
    });

    // Define table headers with custom widths
    const headers = [
      { header: "Key", width: 50 },
      { header: "Name", width: 25 },
      { header: "Is Active", width: 25 },
      { header: "Enabled", width: 25 },
      { header: "Created At", width: 50 },
    ];

    // Map data with formatting
    const data = patients?.map((item) => [
      item?.key,
      item?.name,
      item?.active ? "Yes" : "No",
      item.enabled ? "Yes" : "No",
      item.created_at,
    ]);

    // Add title
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text(
      "Organization Settings List",
      doc.internal.pageSize.getWidth() / 2,
      15,
      {
        align: "center",
      },
    );

    // Add timestamp
    doc.setFontSize(10);
    doc.setFont(undefined, "normal");
    doc.text(`Generated on: ${dayjs().format("YYYY-MM-DD HH:mm:ss")}`, 14, 22);

    // Configure table
    doc.autoTable({
      startY: 30,
      head: [headers.map((h) => h.header)],
      body: data,
      theme: "grid",
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        align: "center",
        lineWidth: 0.5,
        lineColor: [200, 200, 200],
        fontSize: 8,
      },
      bodyStyles: {
        fontSize: 8,
        lineColor: [200, 200, 200],
        lineWidth: 0.5,
      },
      alternateRowStyles: {
        fillColor: [248, 248, 248],
      },
      columnStyles: headers.reduce((acc, h, i) => {
        acc[i] = { cellWidth: h.width };
        return acc;
      }, {}),
      margin: { top: 30, right: 14, bottom: 20, left: 14 },
      didDrawPage: (data) => {
        // Add page number at the bottom
        doc.setFontSize(10);
        doc.text(
          `Page ${data.pageNumber} of ${data.pageCount}`,
          doc.internal.pageSize.getWidth() / 2,
          doc.internal.pageSize.getHeight() - 10,
          { align: "center" },
        );
      },
    });

    // Save with formatted filename including timestamp
    const filename = `Organization-Settings${dayjs().format(
      "YYYYMMDD_HHmmss",
    )}.pdf`;
    doc.save(filename);
  };

  const groupedFeatures =
    OrgListData?.payload?.features?.reduce((acc, item) => {
      const category = item.category || "Others";

      if (!acc[category]) {
        acc[category] = [];
      }

      acc[category].push(item);

      return acc;
    }, {}) || {};
  return (
    <>
      <Header />
      <Sidebar activeClassName="origination--list" />
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Organization Feature</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right" />
                  </li>
                  <li className="breadcrumb-item active">
                    Organization Feature List
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="settings-menu-links">
            <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item ">
                <Link className="nav-link " to="/admin/organization">
                  Organization Details
                </Link>
              </li>
              {/* <li className="nav-item ">
                <Link className="nav-link" to="/admin/organization_settings">
                  Organization Settings
                </Link>
              </li> */}
              <li className="nav-item active">
                <Link className="nav-link" to="/admin/organization_feature">
                  Organization feature
                </Link>
              </li>
            </ul>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Organization Settings List</h3>
                          <div className="doctor-search-blk">
                            <div className="add-group">
                              <Link
                                to="/admin/add_organization_feature"
                                className="btn btn-primary add-pluss ms-2"
                              >
                                <img src={plusicon} alt="#" />
                              </Link>
                              <Link
                                onClick={OrgListRefetch}
                                className="btn btn-primary doctor-refresh ms-2"
                              >
                                <img src={refreshicon} alt="#" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        {/* <Link id="download-pdf" to="#" className=" me-2"> */}
                        <img
                          className=" me-2"
                          onClick={() =>
                            downloadPdf(OrgListData?.payload?.features)
                          }
                          src={pdficon}
                          alt="#"
                          style={{ cursor: "pointer" }}
                        />
                        {/* </Link> */}
                        {/* <Link
                           
                            id="download-csv"
                            className=" me-2"
                          > */}
                        <img
                          onClick={() =>
                            generateCsv(OrgListData?.payload?.features)
                          }
                          className=" me-2"
                          src={pdficon3}
                          alt="#"
                          style={{ cursor: "pointer" }}
                        />
                        {/* </Link> */}
                        {/* <Link id="show-json" to="#"> */}
                        <img
                          onClick={() =>
                            handleShowJson(OrgListData?.payload?.features)
                          }
                          width={"25px"}
                          height={"26px"}
                          src={pdficon5}
                          alt="#"
                          style={{ cursor: "pointer" }}
                        />
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>
                  {/* /Table Header */}

                  <div className="feature-accordion">
                    <Collapse
                      accordion={false}
                      defaultActiveKey={Object.keys(groupedFeatures)}
                      expandIconPosition="end"
                    >
                      {Object.entries(groupedFeatures).map(
                        ([category, features]) => (
                          <Panel
                            key={category}
                            header={
                              <div className="d-flex justify-content-between align-items-center w-100 pe-3">
                                <span
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "15px",
                                  }}
                                >
                                  {category}
                                </span>

                                <Badge
                                  count={features.length}
                                  style={{
                                    backgroundColor: "#1677ff",
                                  }}
                                />
                              </div>
                            }
                          >
                            <Table
                              loading={OrgListLoader}
                              columns={columns.filter(
                                (col) => col.dataIndex !== "category",
                              )}
                              dataSource={features}
                              rowKey={(record) => record.id}
                              pagination={false}
                              bordered
                              size="middle"
                              scroll={{ x: "max-content" }}
                            />
                          </Panel>
                        ),
                      )}
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="notification-box">
          <div className="msg-sidebar notifications msg-noti">
            <div className="topnav-dropdown-header">
              <span>Messages</span>
            </div>
            <div className="drop-scroll msg-list-scroll" id="msg_list">
              <ul className="list-box">
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">R</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Richard Miles </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item new-message">
                      <div className="list-left">
                        <span className="avatar">J</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">John Doe</span>
                        <span className="message-time">1 Aug</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">T</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">
                          {" "}
                          Tarah Shropshire{" "}
                        </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">M</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Mike Litorus</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">C</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">
                          {" "}
                          Catherine Manseau{" "}
                        </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">D</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">
                          {" "}
                          Domenic Houston{" "}
                        </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">B</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Buster Wigton </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">R</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Rolland Webber </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">C</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Claire Mapes </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">M</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Melita Faucher</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">J</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Jeffery Lalor</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">L</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Loren Gatlin</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">T</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Tarah Shropshire</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link to="#">See all messages</Link>
            </div>
          </div>
        </div>
      </div>
      <div
        id="delete_patient"
        className="modal fade delete-modal"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              <h3>Are you sure want to {enable} this feature ?</h3>
              <div className="m-t-20">
                {" "}
                <Link
                  to="#"
                  className="btn btn-white me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </Link>
                <button
                  onClick={handleEnableDisableFeature}
                  type="submit"
                  style={{ color: "white" }}
                  className="btn btn-primary submit-form me-2"
                  data-bs-dismiss="modal"
                >
                  {enable}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrgFeature;
